import { useMutation } from '@tanstack/react-query';
import { fetchData, ValidationError } from 'utils';
import useError from 'hooks/useError';
import useSmartlook from 'hooks/useSmartlook';

function usePrecheckApplicationMutation() {
  const { showError } = useError();
  const { error } = useSmartlook();
  return useMutation<
    {
      rejected: boolean;
    },
    unknown,
    void
  >({
    mutationFn: async () => {
      try {
        return await fetchData('/client/application/pre-check', {
          method: 'post',
        });
      } catch (e) {
        error(
          '[usePrecheckApplicationMutation][POST /client/application/pre-check]',
          e,
        );
        if (!(e instanceof ValidationError)) {
          showError();
          throw e;
        }
      }
    },
  });
}

export default usePrecheckApplicationMutation;
